module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-post-c12067d9.svg";